import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Timer from './Speech/Timer';
import Score from './Speech/Score';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faHourglass } from '@fortawesome/free-solid-svg-icons';
import MicCheck from '../../UI/MicCheck';
import { createRipple } from '../../UI/Button';
import { useTranslation } from 'react-i18next';

// const speechsdk = require('microsoft-cognitiveservices-speech-sdk');
// let recognizer = null;

const AudioListener = ({
  buttonToggled,
  buttonComplete,
  part,
  completeButton = () => { },
  autoPlay = true,
}) => {
  const { t: translate } = useTranslation();
  const params = useParams();
  const lesson = params.lesson;

  const dispatch = useDispatch();
  const score = useSelector((state) => state.currentButtonScore);
  const recognitionText = useSelector((state) => state.recognitionText);
  const microphoneActive = useSelector((state) => state.microphoneActive);
  const activeSection = useSelector((state) => state.activeSection);
  let audioPlayer = useSelector((state) => state.playButtonAudio);

  //Stop practise part initialising too early on first section of lesson 3
  if (parseInt(lesson) === 3) {
    if (activeSection === 0) {
      audioPlayer = true;
      document
        .getElementById('main_audio_player')
        .addEventListener('ended', function () {
          initMic();
        });
    } else {
      //All other sections can use redux
      audioPlayer = useSelector((state) => state.playNpcAudio);
    }
  }
  const audioPlaying = audioPlayer;
  let showRetry = false;
  let showSkip = false;
  let showText = true;
  let practiseClasses = 'practise-controls';
  let content;

  if (lesson > 1 && buttonToggled === true) {
    showSkip = true;
  }

  if (lesson === '1' && microphoneActive === true) {
    showSkip = true;
  }

  if (score < 65 && score !== null) {
    showRetry = true;
    showSkip = true;
  }

  if (buttonToggled === true) {
    if (buttonComplete !== true) {
      practiseClasses = 'practise-controls practise-controls--active';

      if (audioPlaying && parseInt(lesson) < 3) {
        content = <div className="hourglass-loader">
          <FontAwesomeIcon icon={faHourglass} size="2x" />
        </div>
      } else {
        if (autoPlay !== true) {
          content =
            <Fragment>
              <Timer />
              <div
                id={`listen_button_${part}`}
                className={`practise-button ${microphoneActive ? 'practise-button--disabled' : ''
                  }`}
                onClick={(e) => { createRipple(e) }}
              >
                <FontAwesomeIcon icon={faMicrophone} size="1x" />
              </div>
            </Fragment>;
        }

        if (score >= 0 && score !== null) {
          content = <Score score={score} />;
        } else if (score === null && microphoneActive) {
          content = <Timer />;
        }
        
        if ( microphoneActive === false && score === null && autoPlay === true) {
          content =
            <Fragment>
              <div className="hourglass-loader">
                <FontAwesomeIcon icon={faHourglass} size="2x" />
              </div>
              <p className="practise-result">{translate('loading')}</p>
            </Fragment>
        }

        if (recognitionText.includes('Attempting recognition')) {
          content =
            <div className="hourglass-loader">
              <FontAwesomeIcon icon={faHourglass} size="2x" />
            </div>
        }
        
        if (recognitionText.includes('RECOGNISED') && score === null) {
          content =
            <div className="hourglass-loader">
              <FontAwesomeIcon icon={faHourglass} size="2x" />
            </div>
        }

        //Handle errors
        if (recognitionText.includes('NOMATCH') ||
          recognitionText.includes('ERROR') ||
          recognitionText.includes('Server Error') ||
          recognitionText.includes('MIC ERROR')
        ) {
          content = '';
          showRetry = true;

          //Server failed so no point retrying, allow user to skip and carry on.
          if (recognitionText.includes('Server Error')) {
            showRetry = false;
            showSkip = true;
          }

          if (recognitionText === 'MIC ERROR') {
            content = <MicCheck />
            showRetry = false;
            practiseClasses = 'practise-controls practise-controls--active practise-controls--error';
            showText = false;
            showSkip = true;
          }
        }

        if( ! content && showRetry === false || recognitionText === translate('nothing-heard') ) {
          content = <div
            id={`listen_button_${part}`}
            className={`fallback-button practise-button ${microphoneActive ? 'practise-button--disabled' : ''
              }`}
            onClick={(e) => { createRipple(e) }}
          >
            <FontAwesomeIcon icon={faMicrophone} size="1x" />
          </div>
        }
      }
    }
  }

  const completePractise = () => {
    completeButton();
  };

  const initMic = () => {
    dispatch({
      type: 'startSpeechRecognition',
    });
  };

  const tryAgain = () => {
    dispatch({
      type: 'retryAudio',
    });
  };

  useEffect(() => {
    //Check if audio is finished on a button that is checked
    if (buttonToggled === true && audioPlaying === false && autoPlay === true) {
      initMic();
    }
  }, [buttonToggled, audioPlaying]);

  useEffect(() => {
    if (document.getElementById(`listen_button_${part}`)) {
      document.getElementById(`listen_button_${part}`).addEventListener(
        'click',
        function () {
          // console.log('listen click event');
          initMic();
        },
        true,
      );
    }
  })

  useEffect(() => {
    let retry_button = document.getElementById(`retry_button_${part}`);
    if (retry_button) {
      retry_button.addEventListener(
        'click',
        function () {
          // console.log('click event listener');
          // initMic()
          tryAgain();
        },
        true,
      );
    }
  }, [score]);

  return (
    <div className={practiseClasses}>
      <p className="practise-text">{translate('practise-phrase')}</p>
      <div className='practise-content'>
        {content}
        {recognitionText && showText && <p className="practise-result">{recognitionText}</p>}
        {showRetry && (
          <div
            id={`retry_button_${part}`}
            className="practise-button practise-button--attention"
            style={{ marginTop: '10px' }}
          >
            <span>{translate('retry')}</span>
          </div>
        )}
      </div>
      {showSkip && (
        <p className="practise-skip" onClick={completePractise}>{translate('skip')}</p>
      )}
    </div>
  );
};

export default AudioListener;
